import React from 'react'
import ReactDOM from 'react-dom'
import eventBus from '../../../../../util/eventBus'
import Filt from "./views/Filt"
import Nav from "./views/Nav"
import Chart from "./views/Chart"
import { getNullDataTips } from "./views/utils/config"
import { getCradConfig } from "./views/charts/index"

import "./style/kdesign.css"
import "./style/plat.css"
import "./style/style.less"

const normalScheme = { id: "NScheme", schemeName: "常用条件过滤", default: false }
const _schemes = [
    normalScheme,
    { id: "10000", schemeName: "方案A", default: false },
    { id: "10001", schemeName: "方案B", default: false },
];
const _cardConfig = {
    "baseCardSize": { "w": 180, "h": 40, "xSpace": 54, "ySpace": 28, "xSpace2r": 15, "ySpace2v": 15 },
    "cardModelHeightMap": { "1010": 40 },
    "cardModelMap": {
        "1010": [
            { "tag": "rect", "x": 0, "y": 0, "w": 180, "h": 2, fill: "#3f8" },
            { "text": () => ["我是卡片"], "tag": "text", "x": 4, "y": 0, "w": 172, "h": 40, "fontSize": 12, "fontWeight": 100, "color": "#212121", "wMode": "lr", "valign": "center", "textAnchor": "middle", "lineNums": 2 }
        ],
        "1010V": [
            { "tag": "rect", "x": 0, "y": 0, "w": 40, "h": 2, fill: "#3f8" },
            { "text": () => ["我是卡片"], "tag": "text", "x": 0, "y": 4, "w": 40, "h": 172, "fontSize": 12, "fontWeight": 100, "color": "#212121", "wMode": "tb", "valign": "center", "textAnchor": "middle", "lineNums": 2 }
        ]
    }
};
const _mateData = { "checkable": false, "org": "100000", "parentid": "", "boid": "1397712410122403840", "longText": "汉鼎东山分公司", "number": "KE002", "otclassify": "1010", "isPermOrg": 1, "data": "1020", "text": "汉鼎东山分公司", "index": 1, "isOpened": true, "labelPara": [], "showFields": { "name": "汉鼎东山分公司" }, "id": "1397712410122403840", "disabled": false, "orgType": "1020", "expend": false, "leaf": false, "children": [{ "checkable": false, "org": "100000", "level": 4, "parentid": "1397712410122403840", "boid": "1397713216653507584", "longText": "汉鼎山东威海事业部", "number": "KE003", "otclassify": "1010", "isPermOrg": 1, "data": "1040", "text": "汉鼎山东威海事业部", "index": 1, "isOpened": false, "labelPara": [], "showFields": { "name": "汉鼎山东威海事业部" }, "id": "1397713216653507584", "disabled": false, "orgType": "1040", "expend": false, "leaf": true }, { "checkable": false, "org": "100000", "level": 4, "parentid": "1397712410122403840", "boid": "1400031494541411328", "longText": "汉鼎山东菏泽事业部", "number": "4532432423", "otclassify": "1010", "isPermOrg": 1, "data": "1020", "text": "汉鼎山东菏泽事业部", "index": 2, "isOpened": false, "labelPara": [], "showFields": { "name": "汉鼎山东菏泽事业部" }, "id": "1400031494541411328", "disabled": false, "orgType": "1020", "expend": false, "leaf": false, "children": [{ "checkable": false, "org": "100000", "level": 5, "parentid": "1400031494541411328", "boid": "1415056108594140160", "longText": "公司gy050705", "number": "AD-000140", "otclassify": "1010", "isPermOrg": 1, "data": "1020", "text": "公司gy050705", "index": 2, "isOpened": false, "labelPara": [], "showFields": { "name": "公司gy050705" }, "id": "1415056108594140160", "disabled": false, "orgType": "1020", "expend": false, "leaf": true }, { "checkable": false, "org": "100000", "level": 5, "parentid": "1400031494541411328", "boid": "1397701197682458624", "longText": "b131", "number": "b131", "otclassify": "1010", "isPermOrg": 1, "data": "1020", "text": "b131", "index": 4, "isOpened": false, "labelPara": [], "showFields": { "name": "b131" }, "id": "1397701197682458624", "disabled": false, "orgType": "1020", "expend": false, "leaf": true }] }, { "checkable": false, "org": "100000", "level": 4, "parentid": "1397712410122403840", "boid": "1415060021611336704", "longText": "a0744", "number": "AD-000134", "otclassify": "1010", "isPermOrg": 1, "data": "1020", "text": "a0744", "index": 4, "isOpened": false, "labelPara": [], "showFields": { "name": "a0744" }, "id": "1415060021611336704", "disabled": false, "orgType": "1020", "expend": false, "leaf": true }] };

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----station init', props)
            setHtml(this.model, props)
        },
        update: function (props) {
            console.log('-----station update', props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            // console.log('-----destoryed', this.model)
            ReactDOM.unmountComponentAtNode(this.model.dom)
        }
    }

    const setHtml = function (model, primaryProps) {
        KDApi.loadFile('./css/index.css', model, () => {

            class Root extends React.Component {
                constructor(props) {
                    super(props)

                    const params = props?.customProps?.data ?? null
                    const data = params?.data ?? null

                    this.state = {
                        model: props.model,
                        searchLoading: false,
                        filtItems: {
                            ...this.makeFiltParams(data)
                        },
                        showScheme: data?.showScheme ?? normalScheme,
                        schemes: [normalScheme, ...(data?.schemes ?? [])],
                        hasPositionExportPerm: data?.hasPositionExportPerm ?? 0,  //导出权限
                        hasPositionDetailsPerm: data?.hasPositionDetailsPerm ?? 0, //岗位穿透详情权限
                        maxLevel: 5,
                        nullData: getNullDataTips(),
                        mateData: data?.positionNodeData ?? null,
                        preShowScheme: null
                    }

                    this.initMyInvoke(props.model)

                }

                componentDidMount() {
                    this.updateSub = eventBus.sub(model, 'update', (updateProps) => {
                        const data = updateProps?.data?.data ?? null
                        if (!data || Object.keys(data).length === 0) {
                            this.setState({
                                searchLoading: false
                            })
                            return
                        }

                        const eventName = updateProps?.data?.eventName ?? ""

                        this.handleMyInvoke(eventName, updateProps)

                        // console.log("eventName", eventName);
                        console.log("data", data);


                        switch (eventName) {
                            case "searchChartData":
                                this.setState((state, props) => {
                                    const _mateData = data?.positionNodeData ?? null
                                    if (!_mateData) {
                                        state.filtItems.station = null
                                    }
                                    return {
                                        mateData: _mateData,
                                        searchLoading: false,
                                        filtItems: state.filtItems
                                    }
                                })
                                break;
                            case "schemeQueryOrgChart":

                                this.useScheme(data)
                                break;
                            case "refreshPositionChart":
                                this.refreshParmas(data)
                                break;
                            case "dealtScheme":
                                if (data.updateSchemeList) {
                                    const _schemes = data?.schemes ?? []

                                    this.setState({
                                        schemes: [normalScheme, ..._schemes]
                                    })
                                }
                                break;
                        }

                    })
                }

                useScheme = data => {
                    this.setState({
                        showScheme: data?.showScheme ?? normalScheme,
                        schemes: [normalScheme, ...(data?.schemes ?? [])],
                        filtItems: {
                            ...this.makeFiltParams(data)
                        },
                        mateData: data?.positionNodeData ?? null,
                    })
                }

                refreshParmas = data => {
                    this.setState({
                        showScheme: data?.showScheme ?? normalScheme,
                        schemes: [normalScheme, ...(data?.schemes ?? [])],
                        hasPositionExportPerm: data?.hasPositionExportPerm ?? 0,  //导出权限
                        hasPositionDetailsPerm: data?.hasPositionDetailsPerm ?? 0, //岗位穿透详情权限
                        mateData: data?.positionNodeData ?? null,
                        filtItems: {
                            ...this.makeFiltParams(data)
                        },
                    })
                }

                componentWillUnmount() {
                    eventBus.unsub(this.updateSub)
                }

                // 注册myInvoke
                initMyInvoke(model) {
                    this.updateCallBackMap = {}

                    this.myInvoke = (key, params, cbKey) => {
                        return new Promise((resolve, reject) => {
                            model.invoke(key, params)
                            if (cbKey) {
                                this.updateCallBackMap[cbKey] = updateProps => {
                                    const data = updateProps?.data?.data ?? null
                                    const code = updateProps?.data?.code ?? ""

                                    console.log("data:", data);
                                    console.log("code:", code);

                                    if (code === "200" && data && Object.keys(data).length > 0) {
                                        resolve(data)
                                    } else {
                                        reject(data)
                                    }
                                }
                            } else {
                                // 无回调
                            }
                        })
                    }
                }

                handleMyInvoke(eventName, eventProps) {
                    if (this.updateCallBackMap[eventName]) {
                        this.updateCallBackMap[eventName](eventProps)
                        return true
                    }
                    return false
                }

                // 注册单向响应
                initSingleEvent() {
                    this.singleEventMap = {}

                    this.makeSingleEvent = (key, event) => {
                        this.singleEventMap[key] = function (updateProps) {
                            const data = updateProps?.data ?? null
                            const code = data?.code ?? ""
                            if (code === "200") {
                                event(data)
                            } else {
                                console.error("请求错误");
                            }
                        }
                    }
                }

                handleSingleEvent(eventName, eventProps) {
                    if (this.singleEventMap[eventName]) {
                        this.singleEventMap[eventName](eventProps)
                        return true
                    }
                    return false
                }

                updateState = (key, val) => {
                    this.setState({
                        [key]: val
                    })
                }

                refreshPage = () => {
                    this.state.model.invoke("refreshPositionChart", {
                        ...this.getFullParams()
                    })
                }

                getFullParams = () => {
                    const filtItems = this.state.filtItems
                    const params = {
                        orgs: (filtItems?.orgs ?? []).map(item => item.id),
                        coopreltypes: [filtItems?.showCooprelTypes?.id ?? null],
                        orgchartdirection: filtItems?.orgchartdirection ?? "1",
                        showlevel: parseInt(filtItems?.showLevel ?? 1) + "",
                        positionId: filtItems?.station?.id ?? null,
                        chartStyleId: filtItems?.chartStyle?.id ?? null,
                        datefield: filtItems?.queryDate ?? new Date(),
                        queryDate: filtItems?.queryDate ?? new Date(),
                    }

                    console.log("查询参数", params);

                    return params
                }

                makeFiltParams = data => {
                    return {
                        orgs: data?.orgs ?? [],
                        queryDate: data?.queryDate ?? new Date(),
                        station: data?.positionId ?? null,
                        showCooprelTypes: (data?.showCooprelTypes ?? [null])[0],
                        chartStyle: data?.MATCH_CHART_STYLE_KEY ?? null,
                        orgchartdirection: data?.orgchartdirection ?? "1",
                        showLevel: parseInt(data?.showLevel ?? 3)
                    }
                }

                render() {
                    const {
                        model, searchLoading, filtItems, showScheme, schemes,
                        hasPositionExportPerm, hasPositionDetailsPerm,
                        maxLevel, nullData, mateData, preShowScheme
                    } = this.state

                    const myInvoke = this.myInvoke

                    const carddimensionIdCardStyleMap = filtItems.chartStyle?.carddimensionIdCardStyleMap ?? null

                    const cardConfig = getCradConfig(carddimensionIdCardStyleMap)

                    return (
                        <div className="station-container">
                            <Nav
                                model={model}
                                myInvoke={myInvoke}
                                hasPositionExportPerm={hasPositionExportPerm}
                                currentNodeIsNull={!mateData}
                                direction={filtItems.orgchartdirection}
                                refreshPage={this.refreshPage}
                            />
                            <Filt
                                model={model}
                                searchLoading={searchLoading}
                                filtItems={filtItems}
                                showScheme={showScheme}
                                schemes={schemes}
                                maxLevel={maxLevel}
                                updateState={this.updateState}
                                myInvoke={myInvoke}
                                getFullParams={this.getFullParams}
                                preShowScheme={preShowScheme}
                            />
                            <Chart
                                model={model}
                                nullData={nullData}
                                mateData={mateData}
                                direction={filtItems.orgchartdirection}
                                hasPositionDetailsPerm={hasPositionDetailsPerm}
                                filtItems={filtItems}
                                {...cardConfig}
                            />
                        </div>
                    )
                }
            }

            ReactDOM.render(<Root model={model} customProps={primaryProps} />, model.dom)
        })
    }

    // 注册自定义组件
    KDApi.register('kdchart2station', MyComponent)
})(window.KDApi)
